import React from 'react';
import './ActionButtons.scss';

export interface ActionButtonsProps {
  showButtons?: {
    view?: boolean;
    start?: boolean;
    procedureLock?: boolean;
    flowModelLock?: boolean;
    edit?: boolean;
    copy?: boolean;
    tags?: boolean;
    delete?: boolean;
  };
  onViewClick?: () => void;
  onStartClick?: () => void;
  onProcedureLockClick?: () => void;
  onFlowModelLockClick?: () => void;
  onEditClick?: () => void;
  onCopyClick?: () => void;
  onTagsClick?: () => void;
  onDeleteClick?: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  showButtons: showButtons = {},
  onViewClick,
  onStartClick,
  onProcedureLockClick,
  onFlowModelLockClick,
  onEditClick,
  onCopyClick,
  onTagsClick,
  onDeleteClick
}) => {
  return (
    <div className="action-buttons-container">
      {(onViewClick || showButtons.view) && (
        <button
          type="button"
          className="action-button view-button"
          onClick={onViewClick}
          disabled={!onViewClick}
          aria-label="View"
          data-testid="action-view-button"
          title="View process map"
        >
          <i className="fa-light fa-eye"></i>
        </button>
      )}

      {(onStartClick || showButtons.start) && (
        <button
          type="button"
          className="action-button start-button"
          onClick={onStartClick}
          disabled={!onStartClick}
          aria-label="Start"
          data-testid="action-start-button"
          title="Start flow"
        >
          <i className="fa-light fa-play"></i>
        </button>
      )}

      {(onProcedureLockClick || showButtons.procedureLock) && (
        <button
          type="button"
          className="action-button lock-button"
          onClick={onProcedureLockClick}
          disabled={!onProcedureLockClick}
          aria-label="Edit sharing"
          data-testid="action-procedure-lock-button"
          title="Edit sharing"
        >
          <i className="fa-light fa-lock-keyhole"></i>
        </button>
      )}

      {(onFlowModelLockClick || showButtons.flowModelLock) && (
        <button
          type="button"
          className="action-button lock-button"
          onClick={onFlowModelLockClick}
          disabled={!onFlowModelLockClick}
          aria-label="Edit sharing, Flow Model Owners, and Report Owners"
          data-testid="action-flow-model-lock-button"
          title="Edit sharing, Flow Model Owners, and Report Owners"
        >
          <i className="fa-light fa-lock-keyhole"></i>
        </button>
      )}

      {(onEditClick || showButtons.edit) && (
        <button
          type="button"
          className="action-button edit-button"
          onClick={onEditClick}
          disabled={!onEditClick}
          aria-label="Edit"
          data-testid="action-edit-button"
          title="Edit"
        >
          <i className="fa-light fa-pencil"></i>
        </button>
      )}

      {(onCopyClick || showButtons.copy) && (
        <button
          type="button"
          className="action-button copy-button"
          onClick={onCopyClick}
          disabled={!onCopyClick}
          aria-label="Copy"
          data-testid="action-copy-button"
          title="Copy"
        >
          <i className="fa-light fa-copy"></i>
        </button>
      )}

      {(onTagsClick || showButtons.tags) && (
        <button
          type="button"
          className="action-button tags-button"
          onClick={onTagsClick}
          disabled={!onTagsClick}
          aria-label="View Tags"
          data-testid="action-tags-button"
          title="View Tags"
        >
          <i className="fa-light fa-tag"></i>
        </button>
      )}

      {(onDeleteClick || showButtons.delete) && (
        <button
          type="button"
          className="action-button delete-button"
          onClick={onDeleteClick}
          disabled={!onDeleteClick}
          aria-label="Delete"
          data-testid="action-delete-button"
          title="Delete"
        >
          <i className="fa-light fa-trash-can"></i>
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
